import axios from "axios";
import type { ContactFormData, ApiResponse } from "../Types/contact.types";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";

export const submitContactForm = async (
  formData: ContactFormData
): Promise<ApiResponse> => {
  try {
    const response = await axios.post(`${API_URL}/contacts`, formData);
    return { success: true, data: response.data };
  } catch (error: any) {
    return {
      success: false,
      message:
        error.response?.message || "Failed to submit form. Please try again. ",
    };
  }
};
